module.exports = __webpack_public_path__ + "static/media/ayub_ali.f53fba0d.png";